"use strict";
/**
 * StorageService - Manages local storage of offline form submissions
 * Stores up to 500 submissions in localStorage with UUID tracking
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageService = void 0;
class StorageService {
    /**
     * Save a new submission to localStorage
     * Generates UUID and timestamp automatically
     */
    static saveSubmission(data) {
        try {
            const submissions = this.getSubmissions();
            // Check if we've reached the limit
            if (submissions.length >= this.MAX_SUBMISSIONS) {
                throw new Error(`Storage limit reached (${this.MAX_SUBMISSIONS} submissions)`);
            }
            // Create new record with ID and timestamp
            const record = {
                id: this.generateUUID(),
                timestamp: Date.now(),
                ...data,
            };
            submissions.push(record);
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify(submissions));
        }
        catch (error) {
            console.error('Error saving submission:', error);
            throw error;
        }
    }
    /**
     * Retrieve all submissions from localStorage
     */
    static getSubmissions() {
        try {
            const data = localStorage.getItem(this.STORAGE_KEY);
            if (!data) {
                return [];
            }
            return JSON.parse(data);
        }
        catch (error) {
            console.error('Error retrieving submissions:', error);
            return [];
        }
    }
    /**
     * Clear all submissions after export
     */
    static clearAll() {
        try {
            localStorage.removeItem(this.STORAGE_KEY);
        }
        catch (error) {
            console.error('Error clearing submissions:', error);
            throw error;
        }
    }
    /**
     * Get storage statistics
     */
    static getStorageInfo() {
        try {
            const data = localStorage.getItem(this.STORAGE_KEY);
            const submissions = this.getSubmissions();
            return {
                count: submissions.length,
                sizeKB: data ? (data.length / 1024).toFixed(2) : 0,
            };
        }
        catch (error) {
            console.error('Error getting storage info:', error);
            return { count: 0, sizeKB: 0 };
        }
    }
    /**
     * Generate a UUID v4-like identifier
     * Using crypto.randomUUID() if available, fallback to manual generation
     */
    static generateUUID() {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            return crypto.randomUUID();
        }
        // Fallback for browsers without crypto.randomUUID
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
exports.StorageService = StorageService;
StorageService.STORAGE_KEY = 'fcc-offline-submissions';
StorageService.MAX_SUBMISSIONS = 500;
